import Footer from "../Navbar/Footer";
import Navbar from "../Navbar/Navbar";

const About: React.FC<{}> = () => {
  return (
    <div>
      <Navbar />
      <div className="flex flex-wrap lg:px-[21rem] sm:px-[10rem]">
        <div className="w-full flex items-center sm:flex-nowrap flex-wrap mt-10 gap-5">
          {/* <div className="md:w-1/2 w-full flex sm:justify-start justify-center sm:pe-3">
              <Image
                src={EUPicture}
                width={250}
                height={150}
                alt="EU-Next-Generation-Logo"
              />
            </div> */}
          {/* <div className="md:w-1/2 w-full flex sm:justify-end justify-center sm:ps-3">
              <Image
                src={recoveringPicture}
                width={250}
                height={150}
                alt="recovering-plan-logo"
              />
            </div> */}
        </div>

        <div className="w-full flex mt-12">
          <p className="text-center w-full">
            <b>Проект №:</b> &quot; номер на проекта &quot;
          </p>
        </div>

        <div className="w-full flex my-12">
          <p className="text-center w-full">
            <b>Основна цел:</b> Основна цел
          </p>
        </div>

        <div className="w-full flex mt-4 mb-2">
          <p className="text-center w-full">
            Бенефициент: <b>&quot;СОФТ ЗЕН&quot; ЕООД</b>
          </p>
        </div>
        <div className="w-full flex my-2">
          <p className="text-center w-full">
            Начало на проекта: <b>10.03.2025 г.</b>
          </p>
        </div>
        <div className="w-full flex my-2">
          <p className="text-center w-full">
            Край на проекта: <b>10.05.2025 г.</b>
          </p>
        </div>
        <div className="w-full flex my-2">
          <p className="text-center w-full">
            Обща стойност на проекта: <b>х лв</b>, от които европейско
            съфинансиране:, <b>х лв</b>., национално съфинансиране:{" "}
            <b>0,00 лв</b>.
          </p>
        </div>
        <div className="w-full flex my-2">
          <p className="text-center w-full">
            Марка: <b>марка</b>
          </p>
        </div>
        <div className="w-full flex my-2">
          <p className="text-center w-full">
            Модел: <b>модел</b>
          </p>
        </div>
        <div className="w-full flex mt-2">
          <p className="text-center w-full">
            Сериен номер: <b>сериен номер</b>
          </p>
        </div>

        <div className="w-full flex mt-12 mb-4">
          <p className="text-center w-full">
            Настоящият проект се изпълнява с финансовата подкрепа на Национален
            план за възстановяване и устойчивост, по компонент
            &quot;Интелигентна индустрия&quot; на Програма за икономическа
            трансформация.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default About;
